import { defineStore } from 'pinia'

import { actions } from './actions'
import { getters } from './getters'
import { createInitialState } from './state'

export const useActivationStore = defineStore('activation', {
  state: createInitialState,
  actions,
  getters,
})
